import { AxiosInstance } from 'axios'

import { toGsResponse } from '../../goodstack'

import { GetPartnerVolunteeringConfigResponse } from './getPartnerVolunteeringConfig.types'

export const getPartnerVolunteeringConfig = async (
  client: AxiosInstance
): Promise<GetPartnerVolunteeringConfigResponse | undefined> =>
  client
    .get<GetPartnerVolunteeringConfigResponse>(`v1/partner/volunteering/config`, {
      withCredentials: true,
      validateStatus: code => [200, 404].includes(code)
    })
    .then(r => toGsResponse(r.status, r.data))
    .then(r => (r.result === 'success' ? r : undefined))
    .catch(() => undefined)
